'use strict';

const data = window.bookingFormQuestions
const binaryQuestion = require('./components/binary-question')

module.exports = {
	name: 'App',

	el: '.js-booking-form',

	components: {
		binaryQuestion
	},

	data: function () {
		return {
			questions: data,
			progress: 0
		};
	},

	// mounted() {
	// 	console.log(this.questions)
	// },

	computed: {
		eligible: function () {
			if (this.progress >= this.questions.length) {
				return true
			}
			return false
		}
	},

	methods: {
		handleAnsweredQuestion: function(response) {
			if (response.eligible) {
				this.progress = response.order + 1
			} else {
				this.progress = response.order
			}
		}
	}

};
